import {Ki} from 'ghostban';

export const Stone = ({ki, size = '10'}: {ki: Ki; size: string}) => {
    if (ki === Ki.Empty) return null;
    if (ki === Ki.Black)
        return (
            <div
                style={{width: size, height: size}}
                className={
                    'rounded-full mr-1 md:mr-0 flex items-center justify-center bg-black'
                }
            />
        );
    if (ki === Ki.White)
        return (
            <div
                style={{width: size, height: size}}
                className={
                    'rounded-full mr-1 md:mr-0 bg-white border border-black'
                }
            />
        );
    return null;
};
